import React from 'react';
import { useFormContext } from 'react-hook-form';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FormControlLabel from '@mui/material/FormControlLabel';
import ControlledSwitch from '@/components/common/form/ControlledSwitch';
import Tooltip from '@/components/common/Tooltip';
import translate from '@/lib/intl/translate';
import { I18nParagraph } from '@/modules/I18n';
import { DONATION_AGG } from '../hooks/useConstituentSearchAdvancedFilter';

function AggregateSwitch() {
  const { control } = useFormContext();

  return (
    <FormControlLabel
      label={
        <>
          {translate('CONSTITUENT_SEARCH_AGGREGATE_LABEL')}
          <Tooltip
            title={
              <div className="px-2 pt-2">
                {translate('CONSTITUENT_SEARCH_AGGREGATE_TOOLTIP', {
                  p: I18nParagraph,
                })}
              </div>
            }
            light
          >
            <span className="text-text-disabled">
              <InfoOutlinedIcon className="ml-2" />
            </span>
          </Tooltip>
        </>
      }
      labelPlacement="end"
      control={
        <ControlledSwitch
          control={control}
          name={DONATION_AGG}
          shouldUnregister
        />
      }
    />
  );
}

export default AggregateSwitch;
